import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BedBpedWestBengalGuidance() {
  return (
    <SeoLandingPage
      path="/west-bengal-bed-bped-admission-odisha"
      title="West Bengal B.Ed / BP.Ed Admission Guidance for Odisha Students | Devbhumi"
      description="Odisha students ke liye West Bengal B.Ed/BP.Ed admission counselling + coaching. Eligibility, documents, admission processing, books and online classes with Bhadrak office support."
      keywords={`West Bengal B.Ed admission Odisha students, West Bengal BP.Ed guidance Odisha, B.Ed from West Bengal for Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="West Bengal B.Ed / BP.Ed Admission Guidance (Odisha Students)"
      intro="If you are an Odisha student searching for West Bengal B.Ed/BP.Ed admission guidance, we provide counselling, eligibility support, admission processing help, study materials and online coaching. Offline support is available from our Bhadrak office."
      bullets={[
        "Counselling for West Bengal B.Ed/BP.Ed admissions",
        "Eligibility and document support",
        "Admission processing guidance end-to-end",
        "Online coaching/classes + study material guidance",
        "Office support in Bhadrak for documents/books",
        "Support for students across Odisha (Bhadrak, Balasore, Baripada, Mayurbhanj)",
      ]}
      areaServed={[
        { "@type": "State", name: "Odisha" },
        { "@type": "State", name: "West Bengal" },
        { "@type": "City", name: "Bhadrak" },
      ]}
      faqs={[
        {
          q: "Can Odisha students apply with your guidance?",
          a: "Yes. We provide counselling and admission processing support for Odisha students.",
        },
        {
          q: "Do you provide coaching support as well?",
          a: "Yes. Coaching support is available via online classes and study material guidance.",
        },
        {
          q: "How do I begin?",
          a: "Call/WhatsApp for counselling. We will guide you on eligibility, documents and the next steps.",
        },
      ]}
    />
  )
}

